import { useSelector } from 'react-redux'
import { modalSelector, setOpenBuyQrTyModal } from '../../../../redux/slices/modal'
import InfoModal from '../InfoModal'

const BuyQrTyModal = () => {
  const { openBuyQrTyModal } = useSelector(modalSelector)

  return (
    <InfoModal
      open={openBuyQrTyModal}
      closeSetter={setOpenBuyQrTyModal}
      className="buy_qr_ty_modal"
      title="Вітаємо"
      subtitle="Дякуємо за придбання QR-квитків"
      info_msg="QR-квиток є дійсним протягом 15 днів з моменту його придбання."
    />
  )
}

export default BuyQrTyModal
